module.exports = __webpack_public_path__ + "static/media/GuidedBreathingActivity.8b7c1839.mp3";